import script from "./ModelComparisonDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelComparisonDetail.vue?vue&type=script&setup=true&lang=js"

import "./ModelComparisonDetail.vue?vue&type=style&index=0&id=7939c07f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7939c07f"]])

export default __exports__